import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const VideoCameraOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function VideoCameraOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="m24 4-7 4.28V4H5C2.24 4 0 6.24 0 9v6c0 2.76 2.24 5 5 5h12v-4.28L24 20V4Zm-9 14H5c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h10v12Zm7-1.57-5-3.06v-2.76l5-3.06v8.88Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default VideoCameraOutlined;